<template>
    <div style="height: 100%">
        <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab title="Strutture - Presidi" id="tbStrutturePresidi">
                <div class="sa-list-component">
                    <b-form @submit.prevent="onSubmitStrutturePresidi">
                        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Struttura:</label>
                                <b-form-select v-model="filtroStrutturePresidi.idStruttura" :options="strutturaOptions" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Presidio:</label>
                                <b-form-input v-model="filtroStrutturePresidi.denominazione" type="search" id="denominazione" placeholder="Presidio"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Tipo Azienda Locale</label>
                                <b-form-select v-model="filtroStrutturePresidi.tipoAziendaLocale" :options="strutturePresidioTipoAziendaLocaleOptions" value-field="descrizione" text-field="descrizione">
                                    <template #first>
                                        <b-form-select-option :value="null"> TUTTI </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                                <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                                <b-button type="reset" v-on:click="onResetStrutturePresidi" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <div class="sa-list-component-header">
                        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                            <b-col lg="3">
                                <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                            </b-col>
                            <b-col lg="9">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="sa-list-component-body">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(idStruttura)="{ item }">
                                    <span>{{ item.denominazioneStruttura }} ({{ item.codiceStruttura }})</span>
                                </template>
                                <template v-slot:cell(denominazione)="{ item }">
                                    <router-link class="sa-edit-link" :to="'/strutturapresidi/view/' + item.id">{{ item.denominazione }} </router-link>
                                </template>
                                <template v-slot:cell(note)="{ item }">
                                    <span>{{ item.note }} </span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizza Presidio" @click="onView(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="eye" variant="outline-secondary"></b-icon>
                                        </b-button>
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Modifica Presidio" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="pencil" variant="outline-secondary"></b-icon>
                                        </b-button>
                                        <!-- <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Presidio" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                <b-icon icon="trash" variant="danger"></b-icon>
              </b-button> -->
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                    <div class="sa-list-component-footer">
                        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                            <b-col lg="3">
                                <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                            </b-col>
                            <b-col lg="9">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Utenti - Presidi" id="tbUtentiPresidi">
                <strutture-presidi-utenti-list-component ref="cmpStrutturePresidiUtentiList"></strutture-presidi-utenti-list-component>
            </b-tab>
        </b-tabs>
    </div>
    <!--     </div> -->
</template>

<script>
import axios from "axios";

import StrutturePresidiUtentiListComponent from "./StrutturePresidiUtentiListComponent.vue";
import StrutturePresidioMixins from "../mixins/StrutturePresidioMixins";
export default {
    components: { StrutturePresidiUtentiListComponent },
    mixins: [StrutturePresidioMixins],
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage.getItem("filtroStrutturePresidi")) {
            me.filtroStrutturePresidi = JSON.parse(sessionStorage.getItem("filtroStrutturePresidi"));
        }
        this.loadDataStrutturePresidioTipoAzienda();
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/strutturepresidi",
            pathResourceStrutture: "/strutture",
            //pathResource: "/utentipresidi",
            filtroStrutturePresidi: { idStruttura: null, tipoAziendaLocale: null },
            itemsUtentiPresidi: [],
            items: [],
            strutturaOptions: [],
            listKey: 0,
            activeTabIndex: 0,
            fields: [
                {
                    label: "Struttura",
                    key: "idStruttura",
                    sortable: true,
                    // thStyle: "width: 18rem",
                },
                {
                    label: "Presidio",
                    key: "denominazione",
                    sortable: true,
                    //thStyle: "width: 18rem",
                },
                {
                    label: "Numero telefono",
                    key: "telefono",
                    //sortable: true,
                    // thStyle: "width: 18rem",
                },
                { label: "Tipo Azienda", key: "tipoAziendaLocale" },
                { label: "Note", key: "note" },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroStrutturePresidi.page = me.currentPage;
            me.filtroStrutturePresidi.forPage = me.perPage;
            axios
                .get(link, { params: me.filtroStrutturePresidi })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onEdit(item) {
            let me = this;
            me.$router.push("strutturapresidi/edit/" + item.id);
        },
        onView(item) {
            let me = this;
            me.$router.push("strutturapresidi/view/" + item.id);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare il profilo  " + item.descrizione)
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                        axios.delete(link + item.id).then(() => {
                            me.loadData();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onResetStrutturePresidi() {
            let me = this;
            me.filtroStrutturePresidi = { idStruttura: null, denominazione: null, tipoAziendaLocale: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroStrutturePresidi", JSON.stringify(me.filtroStrutturePresidi));
            me.loadData();
        },
        onSubmitStrutturePresidi() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroStrutturePresidi", JSON.stringify(me.filtroStrutturePresidi));
            me.loadData();
        },
        loadCodStrutture() {
            let me = this;
            //  if (me.cont === 0) {

            // me.strutturaOptions = [];
            // me.listaStrutture = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
            me.filtroStrutturePresidi.page = me.currentPage;
            me.filtroStrutturePresidi.forPage = me.perPage;
            axios
                .get(link, { params: me.filtroStrutturePresidi })
                .then((response) => {
                    me.rows = response.data.data.recordsNumber;
                    me.listaStrutture = response.data.data;
                    //  me.cont++;
                    me.listaStrutture.forEach((element) => {
                        me.strutturaOptions.push({
                            value: element.id,
                            text: element.denominazione + " (" + element.codiceStruttura + ")",
                        });
                    });
                    me.strutturaOptions.unshift({
                        value: null,
                        text: "-Seleziona Struttura-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
            //  }
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];
            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbStrutturePresidi":
                    me.loadData();
                    break;
                case "tbUtentiPresidi":
                    me.$refs.cmpStrutturePresidiUtentiList.loadData();
                    me.$refs.cmpStrutturePresidiUtentiList.loadPresidi();
                    break;
            }
        },
    },
};
</script>
<style></style>
